type Props = { size?: number; color?: string };

export function IconSubstack({ size = 16, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<path d="M4 6h16M4 11h16M4 16h10" />
		</svg>
	);
}
